import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DEFAULT_VALUE_OPTION,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { useInitialRole } from "App/hooks";

export const RESET_STATE_USERS = {
  id: "",
  username: "",
  password: "",
  confirm_password: "",
  email: "",
  phone_number: "",
  role: 0,
  role_name: null,
  changepassword: 0,
};
export const getAllUsers = async () => {
  try {
    const api = await instance2.get("/users/listuser");
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const deleteUsersById = async (
  id,
  run,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.post(
      "/users/deleteuser",
      {},
      {
        headers: {
          iduser: id,
        },
      }
    );
    run(!run);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_USERS);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "username",
    disablePadding: false,
    label: "USERNAME",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({ setShowModal, formData, setFormData, run }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const role = useInitialRole(false);
  const addUsers = async () => {
    return instance2.post("/users/adduser", {
      ...formData,
    });
  };

  const updateUsers = () => {
    return instance2.post(
      "/users/updateuser",
      {
        ...formData,
      },
      {
        headers: {
          iduser: formData.id,
        },
      }
    );
  };

  const validation = () => {
    if (formData.username === "") {
      return {
        state: false,
        message: "Username tidak boleh kosong",
      };
    }

    if (formData.phone_number === "") {
      return {
        state: false,
        message: "No Hp tidak boleh kosong",
      };
    }

    if (formData.id === "") {
      if (formData.password === "") {
        return {
          state: false,
          message: "Password tidak boleh kosong",
        };
      } else if (formData.password !== formData.confirm_password) {
        return {
          state: false,
          message: "Password dan konfirmasi password tidak sama",
        };
      }
    }

    return {
      state: true,
      message: "success",
    };
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);

    const valid = validation();

    if (valid.state) {
      try {
        if (formData.id === "") {
          await addUsers();
        } else if (formData.id !== "") {
          await updateUsers();
        }
        run(!run);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_USERS);
        setShowModal(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      defaultToastError(valid?.message);
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const passComp = () => {
    if (formData.id === "") {
      return (
        <>
          <Grid item sm={12}>
            <InputTextMaster
              name='password'
              label='Password'
              id='password'
              value={formData.password}
              onChange={handleChange("password")}
              placeholder='*******'
              type={"password"}
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='confirm_password'
              label='Konfimasi Password'
              id='confirm_password'
              value={formData.confirm_password}
              onChange={handleChange("confirm_password")}
              placeholder='*******'
              type={"password"}
            />
          </Grid>
        </>
      );
    } else {
      return (
        <Grid item sm={12}>
          <InputTextMaster
            name='password'
            label='Masukan Password Baru'
            id='password'
            value={formData.password}
            onChange={(e) => {
              setFormData({
                ...formData,
                password: e.target.value,
                changepassword: 1,
              });
            }}
            placeholder='*******'
            type={"password"}
          />
        </Grid>
      );
    }
  };
  return (
    <Modal
      title={`${formData.id === "" ? "Tambah User" : "Update User"}`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='username'
              label='USERNAME'
              id='username'
              value={formData.username}
              onChange={handleChange("username")}
              placeholder='Username'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='email'
              label='EMAIL'
              id='email'
              value={formData.email}
              onChange={handleChange("email")}
              placeholder='User@gmail.com'
              type={"email"}
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='phone_number'
              label='NO HP'
              id='phone_number'
              value={formData.phone_number}
              onChange={handleChange("phone_number")}
              placeholder='081'
            />
          </Grid>

          <Grid item sm={12}>
            <InputOptionMaster
              name='role'
              label='ROLE'
              id='role'
              withSearch={false}
              value={formData.role}
              onChange={handleChange("role")}
              data={role?.length > 0 ? role : [DEFAULT_VALUE_OPTION("Role")]}
            />
          </Grid>

          {passComp()}
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
